import { Colors, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { formattedAmount } from 'modules/banking/lib/paymentHelpers'

export const Amount = ({
  amountCents,
  currency,
  color = undefined,
}: {
  amountCents: number
  currency: string
  color?: Colors
}) => {
  const {
    access: { locale },
  } = useCurrentSession()
  return (
    <Text.Normal size="200" color={color}>
      {amountCents !== 0 ? formattedAmount({ amountCents: amountCents, currency, locale }) : ''}
    </Text.Normal>
  )
}
